<div mat-dialog-title class="main-header-box">
  <div class="cross-icon close-icon">
    <mat-icon mat-dialog-close>clear</mat-icon>
  </div>
</div>
<mat-dialog-content class="dialog-contents">
  <div class="dialog-container">
    <div class="text" [innerHTML]="data.infoData"></div>
    @if (data.tipData) {
    <div class="tip-container">
      <span class="tip-title"
        >{{ 'liveEvents.setup.label.tip' | translate }} :
      </span>
      <span class="tip-text" [innerHTML]="data.tipData"></span>
    </div>
    }
  </div>
  @if (data?.chipData) {
  <div class="chip-btn">
    <qa-button
      [icon]="data?.chipData?.icon"
      (submitted)="openLink()"
      [label]="data?.chipData?.label"
      [isRoundedButton]="true"
    ></qa-button>
  </div>
  }
</mat-dialog-content>
@if (data?.closeButton) {
<mat-dialog-actions align="end">
  <qa-button
    [isRaisedButton]="true"
    [label]="data.closeButton"
    [mat-dialog-close]="true"
    data-cy="close"
  ></qa-button>
</mat-dialog-actions>
}
